"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnconnectedCardTextInput = UnconnectedCardTextInput;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _classnames = _interopRequireDefault(require("classnames"));

var _formik = require("formik");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * A one-off that is similar to the checkbox, but has a text input field.
 * We 'connect()` this component to Formik to allow us to determine if the
 * inner field has a value in it. This allows us to style the input's
 * containing elements.
 * @param {Object} props
 * @param {Object} props.formik Passed the formik values for this form.
 * @param {function} props.handleClick Click callback to provide focus
 */
function UnconnectedCardTextInput(_ref) {
  var formik = _ref.formik,
      placeholder = _ref.placeholder;
  var textInputName = 'segmentOther';

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasFocus = _useState2[0],
      setHasFocus = _useState2[1];

  var value = _lodash["default"].get(formik.values, textInputName);

  var checked = _lodash["default"].get(value, 'length') > 0;
  var contentWrapperClasName = (0, _classnames["default"])('card-content', {
    focus: hasFocus,
    // uses same style as normal checkbox implementation. In this case 'checked' means
    // the input has a value
    checked: checked
  });
  var segmentInputClassName = (0, _classnames["default"])('segment-input', {
    checked: checked
  }); // Allows us to setFocus on the text field when the outer card is clicked

  var textInputRef = _react["default"].useRef(null);

  function handleClick() {
    setHasFocus(true);
    textInputRef.current.focus();
  }

  function setHasFocusTrue() {
    setHasFocus(true);
  }

  function setHasFocusFalse() {
    setHasFocus(false);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "CardCheckbox textInput"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: contentWrapperClasName,
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-background"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-sizing-helper"
  }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    className: segmentInputClassName,
    component: "textarea",
    type: "text",
    name: textInputName,
    placeholder: placeholder,
    innerRef: textInputRef,
    onFocus: setHasFocusTrue,
    onBlur: setHasFocusFalse
  })));
}

UnconnectedCardTextInput.propTypes = {
  placeholder: _propTypes["default"].string.isRequired,
  formik: _propTypes["default"].shape({
    values: _propTypes["default"].shape({})
  }).isRequired
};

var _default = (0, _formik.connect)(UnconnectedCardTextInput);

exports["default"] = _default;